
    import './styles.scoped.css';
    export default {
  "treeitem-group": "awsui_treeitem-group_1agpu_idol5_9",
  "treeitem": "awsui_treeitem_1agpu_idol5_9",
  "offset": "awsui_offset_1agpu_idol5_26",
  "treeitem-content-wrapper": "awsui_treeitem-content-wrapper_1agpu_idol5_29",
  "tree-item-focus-target": "awsui_tree-item-focus-target_1agpu_idol5_34",
  "expand-toggle-wrapper": "awsui_expand-toggle-wrapper_1agpu_idol5_55",
  "toggle": "awsui_toggle_1agpu_idol5_60",
  "with-icon": "awsui_with-icon_1agpu_idol5_66",
  "structured-item-wrapper": "awsui_structured-item-wrapper_1agpu_idol5_83",
  "tree-item-structured-item": "awsui_tree-item-structured-item_1agpu_idol5_90"
};
  